











import { Component, Vue } from "vue-property-decorator";
import ContactDialog from "./ContactDialog.vue";
import { namespace } from "vuex-class";
import { Type } from "../models/message";

const authStore = namespace("auth");
const store = namespace("contact");

@Component({
  components: { ContactDialog },
})
export default class GlobalContactButton extends Vue {
  @authStore.Getter loggedIn!: boolean;
  @store.Mutation private open!: (type: Type) => void;

  private openGlobal() {
    this.open(Type.global);
  }
}
